import { AppRoute } from "../../../constants";

import "./Footer.scss";
//import logo from "../../images/logo-with-text.svg";
import teleg from "../../../images/icons/teleg.svg";
import tel from "../../../images/icons/telephone.svg";
import { Link } from "shared/components/Link";

// const scadaPdf = "";
const scadaPdf = "/Отечественная модульная SCADA система для автоматизации ПС и ЦУС.pdf ";

const footerContacts = [
  {
    img: teleg,
    name: "Телеграм",
    link: "https://t.me/epsaspb",
  },
  {
    img: tel,
    name: "Контакты",
    link: "http://epsa-spb.ru/kontakty-2/",
  },
];

const footerAbout = [
  {
    name: "Презентация о SCADA",
    link: scadaPdf,
  },
  {
    name: "Регистрация в реестре отечественного ПО",
    link: "https://reestr.digital.gov.ru/reestr/304990/",
  },
];




function Footer() {
  return (
    <footer className="footer" style={{ background: 'rgb(18 34 57)' }}>
      <div className="px-1 d-flex flex-wrap footer__container">
        <div
          className="col mt-4"
          style={{ minWidth: "313px", maxWidth: "530px" }}
        >
          <h6
            style={{ color: "var(--blue)", fontSize: "19px" }}
            className="mb-4 text-accent"
          >
            О компании
          </h6>
          <ul className="footer__links d-flex flex-wrap">
            {footerContacts.map((link) => (
              <li
                className="footer__list"
                style={{ marginRight: "20px" }}
                key={link.name}
              >
                <img
                  src={link.img}
                  alt={link.name}
                  className="footer__link-img"
                />
                <Link to={link.link} className="link">
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
          <p className="footer__company-name">Изготовитель и разработчик:</p>
          <Link
            to="http://npt.spb.ru/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-links footer__company-description"
          >
            ООО «Новые программные технологии» (ООО&nbsp;«НПТ»)
          </Link>
          <p className="footer__company-name mt-4">Юридический адрес:</p>
          <p className="footer__company-description">
            194223, Санкт-Петербург, вн.тер.г. муниципальный округ
            Светлановское, ул.&nbsp;Курчатова, д.&nbsp;9, стр.&nbsp;2,
            офис&nbsp;233
          </p>
        </div>
        <div className="col d-flex mt-4 footer__links-container">
          <div style={{ maxWidth: "260px" }}>
            <h6
              style={{ color: "var(--blue)", fontSize: "19px" }}
              className="mb-4 text-accent"
            >
              SCADA NPT Expert
            </h6>
            <ul className="footer__links">
              {footerAbout.map((link) => (
                <li
                  className="footer__list"
                  key={link.name}
                  style={{ minWidth: "310px" }}
                >
                  <a
                    className="link"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={link.link}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
      <div style={{ background: "var(--background)" }}>
        <p className="footer__caption">
          ⓒ {new Date().getFullYear()} SCADA NPT Expert, Все права защищены
        </p>
      </div>
    </footer>
  );
}

export default Footer;
